import '@mdi/font/css/materialdesignicons.css';
import 'vuetify/styles';

import { createVuetify } from 'vuetify';
import { aliases, mdi } from 'vuetify/iconsets/mdi';
import * as components from 'vuetify/components';
import * as directives from 'vuetify/directives';

const vuetify = createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
  display: {
    mobileBreakpoint: 'sm', // กำหนด breakpoint สำหรับ mobile
    thresholds: {
      xs: 0,
      sm: 600,
      md: 960,
      lg: 1280,
      xl: 1920,
    },
  },
  theme: {
    defaultTheme: 'light',
    themes: {
      dgaTheme: {
        dark: false,
        colors: {
          primary: '#FF4F00',
          secondary: '#17144C',
          error: '#B00020',
          info: '#2196F3',
          success: '#4CAF50',
          warning: '#FB8C00',
          surface: '#FFFFFF',
          background: '#F5F7FA',
        },
      },
    },
  },
});

export default vuetify;
